<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-row no-gutters>
          <v-col cols="12" class="pa-2">
            <div class="rowinfo">
              <v-text-field
                outlined
                dense
                class="contentinfo"
                :rules="urlRules"
                v-model="value.windows_url"
                hint="لطفا آدرس لینک  خود را وارد کنید."
                label="آدرس لینک"
                clearable
                clear-icon="mdi-close-circle-outline"
                append-icon="mdi-desktop-tower-monitor"
              >
                <template v-slot:append-outer>
                  <div class="text-no-wrap">: desktop</div>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-value-windows_url`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="آدرس لینک"
              />
            </div>
          </v-col>

          <v-col cols="12" class="pa-2">
            <div class="rowinfo">
              <v-text-field
                outlined
                dense
                :rules="urlRules"
                v-model="value.android_url"
                label="آدرس لینک"
                class="contentinfo"
                clearable
                hint="لطفا آدرس لینک  خود را وارد کنید."
                clear-icon="mdi-close-circle-outline"
                append-icon="mdi-android"
              >
                <template v-slot:append-outer>
                  <div class="text-no-wrap">: android</div>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-value-android_url`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="آدرس لینک"
              />
            </div>
          </v-col>

          <v-col cols="12" class="pa-2">
            <div class="rowinfo">
              <v-text-field
                outlined
                dense
                class="contentinfo"
                :rules="urlRules"
                v-model="value.ios_url"
                hint="لطفا آدرس لینک  خود را وارد کنید."
                label="آدرس لینک"
                clearable
                clear-icon="mdi-close-circle-outline"
                append-icon="mdi-apple-ios"
              >
                <template v-slot:append-outer>
                  <div class="text-no-wrap">: ios</div>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-value-ios_url`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                label="آدرس لینک"
              />
            </div>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
export default {
  name: "manageRedirectQr",

  props: {
    value: Object,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "manger-redirect-Qr",
      urlRules: [
        (value) =>
          this.isURL(value) ||
          "لینک سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      ],
    };
  },

  methods: {
    isURL(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      if (
        !str ||
        regex.test(str) ||
        without_regex.test(str) ||
        str.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.v-input >>> .v-input__append-outer {
  min-width: 100px;
}
</style>
